import { toast } from 'react-toastify';
import API from '../apiClient';

export const fetchOnboardingDetails = (entity) => {
    return new Promise((resolve) => {
      API.get(`/organization/onboarding/${encodeURIComponent(entity)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          toast.error("Something went wrong")
          console.log(error)
        });
    });
  };


  export const UpdateStep = (entity,payload) => {
    return new Promise((resolve,reject) => {
        API.put(`/organization/steps/${encodeURIComponent(entity)}`, payload)
        .then(response => {
            resolve(response);
        }).catch(error =>{
            reject(error);
            console.log(error)
          });
    })

}